(() => {
  if (!window.Shopify?.designMode) return;
  document.addEventListener('shopify:section:load', event => {
    window.CHContent?.capture(event.target);
    event.target.querySelectorAll('.page').forEach(el => el.classList.add('active'));
    event.target.querySelectorAll('.reveal').forEach(el => el.classList.add('in'));
    if (typeof setLang === 'function') setLang(document.documentElement.lang || 'fr');
    window.CHInitFilm?.();
    window.CHInitContact?.();
  });
  document.addEventListener('shopify:block:select', event => {
    event.target.closest('details')?.setAttribute('open', '');
    event.target.scrollIntoView({behavior: 'smooth', block: 'center'});
  });
})();
